import React, { Component } from 'react'
import { AddNewCallDiv, AvatarBreakDiv, BreakBar } from '../styles/dialpadstyle'
import { Spinner } from 'modules/theme'

export class CallPreviewLoading extends Component {
    render() {
        const { blankInfoImg, blankName, blankTime } = this.props;
        return (
            <span style={{display: 'block', width: '100%'}}>
                <AddNewCallDiv>
                    <BreakBar>
                        <AvatarBreakDiv>
                            <img src="/images/PreviewLead.png" />
                        </AvatarBreakDiv>
                        <h4>{blankName}</h4>
                        <h5>{blankTime}</h5>
                        <Spinner style={{ height: '3px', marginTop: '-15px', padding: '10px', marginBottom: '10px' }} />
                    </BreakBar>
                </AddNewCallDiv>
            </span>
        )
    }
}

export default CallPreviewLoading


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/CallPreviewLoading.js